import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import { Loader2, Users } from "lucide-react";
import { Button } from "../components/ui/button";

export default function TontineJoin() {
  const { token } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!user) {
      // Redirect to login then come back
      navigate(`/login?next=${encodeURIComponent(`/tontines/join/${token}`)}`);
    }
  }, [user, token, navigate]);

  const accept = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/tontines/join/${token}`);
      toast.success("Bienvenue dans la tontine !");
      setDone(true);
      setTimeout(() => navigate(`/tontines/${data.tontine_id}`), 500);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Lien invalide");
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="tontine-join-page">
      <div className="card-soft p-8 max-w-md w-full text-center">
        <div className="h-16 w-16 mx-auto mb-4 rounded-2xl gradient-gold-green flex items-center justify-center">
          <Users className="h-8 w-8 text-white" />
        </div>
        <h1 className="font-display text-2xl font-bold mb-2">Rejoindre la tontine</h1>
        <p className="text-muted-foreground mb-6 text-sm">Vous êtes invité·e à rejoindre une tontine sur Sen Natt. Cliquez ci-dessous pour confirmer votre participation.</p>
        <Button onClick={accept} disabled={loading || done} className="btn-gradient rounded-full w-full h-11" data-testid="accept-invite">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : done ? "✓ Rejoint" : "Accepter l'invitation"}
        </Button>
      </div>
    </div>
  );
}
